import { render, staticRenderFns } from "./tenant-add-or-update.vue?vue&type=template&id=4fb62e4e&"
import script from "./tenant-add-or-update.vue?vue&type=script&lang=js&"
export * from "./tenant-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./tenant-add-or-update.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports